<!--
  A small cross at each place an open grid's hairlines meet, from
  useGridJoins. Sits in the grid's positioned wrapper.
-->
<template>
  <span
    v-for="join in joins"
    :key="`${join.x}-${join.y}`"
    class="grid-join pointer-events-none absolute h-[11px] w-[11px] -translate-x-1/2 -translate-y-1/2 text-slate-500/70 dark:text-white/40"
    :style="{ left: `${join.x}px`, top: `${join.y}px` }"
    aria-hidden="true"
  ></span>
</template>

<script setup lang="ts">
defineProps<{ joins: { x: number; y: number }[] }>()
</script>

<style scoped>
/* Two 1px bars. */
.grid-join {
  background:
    linear-gradient(currentColor, currentColor) center / 1px 100% no-repeat,
    linear-gradient(currentColor, currentColor) center / 100% 1px no-repeat;
}
</style>
